import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ParticipantType } from '../../features/conversations/types/Conversation';
import { AI_ASSISTANT_AVATAR_URL } from '../constants/aiAssistantAvatar';
import styles from './ParticipantAvatar.module.css';

type ParticipantAvatarProps = {
  participantType: ParticipantType;
  className?: string;
};

const UserAvatarSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 12.25a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5Zm0 2.25c-4.18 0-7.5 2.36-7.5 5.25 0 .41.34.75.75.75h13.5c.41 0 .75-.34.75-.75 0-2.89-3.32-5.25-7.5-5.25Z"
      fill="currentColor"
    />
  </svg>
);

const SystemAvatarSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 3.75 5.75 6.4v4.12c0 4.11 2.43 7.93 6.25 9.73 3.82-1.8 6.25-5.62 6.25-9.73V6.4L12 3.75Zm0 4.05a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm1.25 8.2h-2.5a.75.75 0 0 1 0-1.5h.75v-2.45h-.55a.75.75 0 0 1 0-1.5h1.3c.41 0 .75.34.75.75v3.2h.25a.75.75 0 0 1 0 1.5Z"
      fill="currentColor"
    />
  </svg>
);

export const ParticipantAvatar: React.FC<ParticipantAvatarProps> = ({ participantType, className }) => {
  const { t } = useTranslation('common');
  const label = participantType === 'aiAssistant'
    ? t('aiAssistantAvatar')
    : participantType === 'system'
      ? t('systemAvatar')
      : t('userAvatar');

  if (participantType === 'aiAssistant') {
    return (
      <span className={className} aria-label={label} role="img">
        <img src={AI_ASSISTANT_AVATAR_URL} alt="" className={styles.avatarImage} />
      </span>
    );
  }

  return (
    <span className={className} aria-label={label} role="img">
      {participantType === 'system'
        ? <SystemAvatarSvg />
        : <UserAvatarSvg />}
    </span>
  );
};

export default ParticipantAvatar;
